"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var core_1 = require("@material-ui/core");
var useStyles = core_1.makeStyles(function (theme) { return ({
    root: {
        padding: 0
    },
    actions: {
        display: 'flex',
        padding: 0
    },
    content: {
        padding: 0,
        // backgroundColor: theme.palette.secondary.main,
        // color: 'white'
        '&:last-child': {
            paddingBottom: 0
        }
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        })
    },
    expandOpen: {
        transform: 'rotate(180deg)'
    },
    avatar: {
        width: 15,
        height: 15
    },
    button: {
        marginTop: 5,
        justifyContent: 'flex-start',
        borderRadius: 0,
        textTransform: 'none'
    },
    category: {
        textTransform: 'none',
        color: 'white'
    }
    // q: { marginLeft: 10 }
}); });
exports.QACategory = function (_a) {
    var id = _a.id, title = _a.title, sub = _a.sub, expand = _a.expand, onCategoryClick = _a.onCategoryClick;
    var classes = useStyles();
    var _b = react_1.default.useState(expand), expanded = _b[0], setExpanded = _b[1];
    var handleExpandClick = sub && sub.length > 0
        ? react_1.default.useCallback(function () { return setExpanded(!expanded); }, [expanded])
        : react_1.default.useCallback(function () { return onCategoryClick("category/" + id); }, [id, onCategoryClick]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.CardContent, { className: clsx_1.default('faq-category', classes.content) },
            react_1.default.createElement(core_1.Button, { color: expanded ? 'default' : 'secondary', variant: "contained", onClick: handleExpandClick, "aria-expanded": expanded, fullWidth: true, className: clsx_1.default(classes.button, {
                    'faq-has-subcategory': sub && sub.length > 0
                }), id: id },
                react_1.default.createElement(core_1.Typography, { className: classes.category, variant: "h4", color: "inherit" }, title))),
        react_1.default.createElement(core_1.Collapse, { in: expanded, timeout: "auto", unmountOnExit: true }, sub &&
            sub.map(function (v) {
                if (!v) {
                    return null;
                }
                var subCategoryId = v.id || '';
                var handleCategoryClick = react_1.default.useCallback(function () { return onCategoryClick("category/" + subCategoryId); }, [subCategoryId]);
                return (react_1.default.createElement(core_1.Button, { fullWidth: true, className: clsx_1.default('faq-subcategory', classes.button), key: subCategoryId, onClick: handleCategoryClick }, v.title));
            }))));
};
//# sourceMappingURL=QACategory.js.map